import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://imd.radom.pl/pushservice'
})

export default instance